// 这是一个封装 axios请求方法 的文件

import axios from "axios";
// import qs from 'qs'
import { AesUtil } from "./AESUtils";
import { SeaAesUtil } from "./SeaAESUtils";
import {
  serverIpAddress,
  serverIpAddressSea,
  httpTimeout,
  imgServerIp,
  tokenOutTime
} from "./systemConfig";
import { sessionSto } from "./sessionStorageManage";
import { cookiesModule } from "./cookiesModule.js";
import { localStorage } from "./localStorageModule.js";
import router from "@/router/index.js";
// import {weChat} from '../src/utils/weChat'

// 爬取手机号 data = {mobile:'15756012997', action: 'mobile'}
window.linkTohttps = data => {
  axios({
    url: "/mobile.asp",
    method: "GET",
    baseURL: "/baiduApis",
    headers: {
      "content-type": "application/json;charset=utf-8"
    },
    params: data
  }).then(res => {
    let doc = new DOMParser().parseFromString(res, "text/html");
    let phoneDom = doc
      .getElementsByClassName("table")[0]
      .getElementsByTagName("tbody")[0]
      .getElementsByTagName("tr")[1]
      .getElementsByTagName("span")[0];
  });
};

// 开发环境使用 dev代理服务， 生产环境使用 服务器域名
var baseURL = process.env.NODE_ENV == "development" ? "/apis" : serverIpAddress;
var seaBaseURL = process.env.NODE_ENV == "development" ? "/seaapis" : serverIpAddressSea;

console.log("baseURL", baseURL)
console.log("seaBaseURL", seaBaseURL)

const imgServerIpAddress = imgServerIp;

// 添加请求拦截器，在发送请求之前做些什么(**具体查看axios文档**)--------------------------------------------
axios.interceptors.request.use(
  function(config) {
    // 显示loading
    return config;
  },
  function(error) {
    // 请求错误时弹框提示，或做些其他事
    return Promise.reject(error);
  }
);

// 添加响应拦截器(**具体查看axios文档**)----------------------------------------------------------------
axios.interceptors.response.use(
  function(response) {
    // 对响应数据做点什么，允许在数据返回客户端前，修改响应的数据
    // 如果只需要返回体中数据，则如下，如果需要全部，则 return response 即可
    return response.data;
  },
  function(error) {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);

// 请求返回失败提示函数---------------------------------------------------------------------------
function errorState(response) {
  if ((response.code = 0)) {
    console.error("处理请求结果存在问题！");
  } else {
    console.error("访问服务器出现异常！");
  }
}

// 封装axios--------------------------------------------------------------------------------------
function apiAxios(method, url, params) {
  let tokenInfo = localStorage.$selectLocalStorage("tokenInfo");
  let locationData = {
    ip: window.Ip,
    timestamp: new Date().getTime()
  };
  let locationInfo = AesUtil.encryptionLoc(JSON.stringify(locationData)).text;
  let headerObj = {};
  headerObj.location = locationInfo;
  let contentType = ""
  if(method == "POST" || method == "PUT"){
    contentType = 'multipart/form-data;charset=utf-8'
  }

  if(method == "GET" || method == "DELETE"){
    contentType = 'application/json;charset=utf-8'
  }
  headerObj["Content-Type"] = contentType
  headerObj.language =
    sessionStorage.getItem("langType") === "en" ? "English" : "chinese";
  if (tokenInfo) {
    headerObj.Authorization = tokenInfo;
  }
  let formData = new FormData();
  if ((method == "POST" || method == "PUT") && params) {
    formData.append("text", AesUtil.getAxiosJSONstr(params).text);
  }
  let httpDefault = {
    method: method,
    baseURL: baseURL,
    url: url,
    headers: headerObj,
    params:
      method == "GET" || method == "DELETE"
        ? AesUtil.getAxiosJSONstr(params)
        : undefined,
    data: method == "POST" || method == "PUT" ? formData : null,
    // 访问超时时间
    timeout: httpTimeout
  };


  // 注意**Promise**使用(Promise首字母大写)
  return new Promise(function(resolve, reject) {
    axios(httpDefault)
      .then(function(res) {
        if (res.code == 200) {
          // 解密data
          if(res.data){
            res.data = AesUtil.getAxiosHeadJSONstr(res.data);
            let data = res.data;
            // 如果data是JSON字符串则转为对象
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              res.data = data;
            }
          }

          if(res.rows){
            res.rows = AesUtil.getAxiosHeadJSONstr(res.rows);
            let rows = res.rows;

            // 如果data是JSON字符串则转为对象
            try {
              res.rows = JSON.parse(res.rows);
            } catch (error) {
              res.rows = rows;
            }
          }
        }
        resolve(res);
      })
      .catch(response => {
        errorState(response);
        reject(response);
      });
  });
}




// 封装axios--------------------------------------------------------------------------------------
function apiAxiosSea(method, url, params) {
  // let tokenInfo = localStorage.$selectLocalStorage("tokenInfo");
  let locationData = {
    ip: window.Ip,
    timestamp: new Date().getTime()
  };
  let locationInfo = SeaAesUtil.encryptionLoc(JSON.stringify(locationData)).text;
  let headerObj = {};
  headerObj.location = locationInfo;
  let contentType = ""
  if(method == "POST" || method == "PUT"){
    contentType = 'multipart/form-data;charset=utf-8'
  }

  if(method == "GET" || method == "DELETE"){
    contentType = 'application/json;charset=utf-8'
  }
  headerObj["Content-Type"] = contentType
  headerObj.language =
    sessionStorage.getItem("langType") === "en" ? "English" : "chinese";
  // if (tokenInfo) {
  //   headerObj.Authorization = tokenInfo;
  // }
  let formData = new FormData();
  if ((method == "POST" || method == "PUT") && params) {
    formData.append("text", SeaAesUtil.getAxiosJSONstr(params).text);
  }
  let httpDefault = {
    method: method,
    baseURL: seaBaseURL,
    url: url,
    headers: headerObj,
    params:
      method == "GET" || method == "DELETE"
        ? SeaAesUtil.getAxiosJSONstr(params)
        : undefined,
    data: method == "POST" || method == "PUT" ? formData : null,
    // 访问超时时间
    timeout: httpTimeout
  };


  // 注意**Promise**使用(Promise首字母大写)
  return new Promise(function(resolve, reject) {
    axios(httpDefault)
      .then(function(res) {
        if (res.code == 200) {
          // 解密data
          if(res.data){
            res.data = SeaAesUtil.getAxiosHeadJSONstr(res.data);
            let data = res.data;
            // 如果data是JSON字符串则转为对象
            try {
              res.data = JSON.parse(res.data);
            } catch (error) {
              res.data = data;
            }
          }

          if(res.rows){
            res.rows = SeaAesUtil.getAxiosHeadJSONstr(res.rows);
            let rows = res.rows;

            // 如果data是JSON字符串则转为对象
            try {
              res.rows = JSON.parse(res.rows);
            } catch (error) {
              res.rows = rows;
            }
          }
        }
        resolve(res);
      })
      .catch(response => {
        errorState(response);
        reject(response);
      });
  });
}

function upLoadApiAxios(method, url, params, formData) {
  let tokenInfo = localStorage.$selectLocalStorage("tokenInfo");
  let headerObj = {};
  if (tokenInfo) {
    headerObj.Authorization = tokenInfo;
  }
  headerObj.language =
    sessionStorage.getItem("langType") === "en" ? "English" : "chinese";
  // if(url.toLocaleUpperCase().indexOf("TOKEN") < 0){
  //   params.accessType = isUsePhone()?2:1
  //   params.ipAddress = sessionStorage["ip"]
  // }
  // let userData = cookiesModule.$getCookieByKey2("userInfo")
  // userData = userData?userData:cookiesModule.$getCookieByKey2("weChatInfo")
  // if(userData && url.toLocaleUpperCase().indexOf("TOKEN") < 0){
  //   userData = JSON.parse(userData)
  //   if(weChat.$browserType() == 'weChat' && !userData.no){
  //     params.openid = userData.openid
  //     params.password = ''
  //   }else{
  //     params.username = userData.no
  //     params.password = ''
  //   }
  // }
  let data = AesUtil.getAxiosJSONstr(params).text;
  formData.append("text", data);
  let httpDefault = {
    method: method,
    baseURL: baseURL,
    url: url,
    headers: headerObj,
    data: formData,
    // 访问超时时间
    timeout: httpTimeout
  };

  // 注意**Promise**使用(Promise首字母大写)
  return new Promise(function(resolve, reject) {
    axios(httpDefault)
      .then(function(res) {
        if (res.code == 200) {
          // 解密data
          res.data = AesUtil.getAxiosHeadJSONstr(res.data);
          let data = res.data;
          // 如果data是JSON字符串则转为对象
          try {
            res.data = JSON.parse(res.data);
          } catch (error) {
            res.data = data;
          }
        }
        resolve(res);
      })
      .catch(response => {
        errorState(response);
        reject(response);
      });
  });
}

// 判断用户是否登录
export function getIsLogin() {
  let flag = false;
  let tokenInfo = localStorage.$selectLocalStorage("tokenInfo");
  if (tokenInfo) {
    if (userinfoTimeout()) {
      flag = true;
    }
  }
  return flag;
}

// 没有登录则回到登录页面
export function unLoginToLoginPage() {
  let flag = getIsLogin();
  if (flag) {
    return true;
  } else {
    isUsePhone()
      ? router.push({ name: "mobile_loginAndRegister" })
      : router.push({ name: "loginAndRegister" });
    return false;
  }
}

// 判断用户信息是否过期
export function userinfoTimeout() {
  // if(weChat.$browserType() == 'weChat'){
  //   return true
  // }
  let loginTimeStamp = localStorage.$selectLocalStorage("outTime");
  let nowTimeStamp = new Date().getTime();
  return nowTimeStamp < parseInt(loginTimeStamp) + tokenOutTime * 60 * 1000;
}

// 获取用户信息
export async function getUserInfo() {
  // 验证是否登录
  let flag = getIsLogin();
  if (!flag) {
    return null;
  }

  // 验证登录信息是否过期
  let flag_2 = userinfoTimeout();
  if (!flag_2) {
    cookiesModule.$delCookieByKey("userInfo");
    localStorage.$deleteAllLocalStorage();
    router.push({ name: "Mobile_login2" });
    return null;
  }

  // 获取用户信息（从cookie）
  var userInfo = cookiesModule.$getCookieByKey2("userInfo");
  if (userInfo) {
    userInfo = JSON.parse(userInfo);
    return userInfo;
  }
  // 获取用户信息（从后台获取，并存入cookie）
  let userGetHttp = await apiAxios("GET", "/getUserInfo");
  cookiesModule.$setNewCookie("userInfo", userGetHttp.data);
  userInfo = userGetHttp.data;
  return userInfo;
}

// 获取用户头像
async function headImg() {
  // 未登录则使用默认头像
  if (!getIsLogin()) {
    return "https://yangzi-manage.oss-cn-shanghai.aliyuncs.com/mall/static/assets/Icon/ic_qrcode.png";
  }
  let user = await getUserInfo();
  if (user.remarks1) {
    return user.remarks1;
  } else if (user.headportrait) {
    return user.headportrait;
  } else {
    return "https://yangzi-manage.oss-cn-shanghai.aliyuncs.com/mall/static/assets/Icon/ic_qrcode.png";
  }
}

export const axiosHttp = {
  $baseURL: baseURL,
  $getAxios: (url, params) => apiAxios("GET", url, params),
  $postAxios: (url, params) => apiAxios("POST", url, params),
  $getAxiosSea: (url, params) => apiAxiosSea("GET", url, params),
  $postAxiosSea: (url, params) => apiAxiosSea("POST", url, params),
  $fileUpLoad: (url, data, formData) =>
    upLoadApiAxios("POST", url, data, formData)
};

// 判断是否为手机端使用
export function isUsePhone() {
  if (navigator.userAgent.match(/(Robot|Spider)/i)) {
    router.push({ name: "notFount" });
  }
  return navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
}

// 输出函数getAxios、postAxios、putAxios、delectAxios，供其他文件调用-----------------------------
// Vue.js的插件应当有一个公开方法 install。这个方法的第一个参数是 Vue 构造器，第二个参数是一个可选的选项对象。
export default {
  install: function(Vue) {
    // 请求相关
    Vue.prototype.$baseURL = baseURL;
    Vue.prototype.$imgServerIpAddress = imgServerIpAddress;
    Vue.prototype.$getAxios = (url, params) => apiAxios("GET", url, params);
    Vue.prototype.$postAxios = (url, params) => apiAxios("POST", url, params);
    Vue.prototype.$putAxios = (url, params) => apiAxios("PUT", url, params);
    Vue.prototype.$delectAxios = (url, params) =>
      apiAxios("DELECT", url, params);
    Vue.prototype.$getImgAxios = (url, params) => apiAxios("GET", url, params);
    Vue.prototype.$postImgAxios = (url, params) =>
      apiAxios("POST", url, params);

    // 判断用户是否登录，
    Vue.prototype.$getIsLogin = () => getIsLogin();

    // 判断用户是否登录， 如果没有登录则返回登录页
    Vue.prototype.$unLoginToLoginPage = () => unLoginToLoginPage();
    // 判断是否为手机端使用
    Vue.prototype.$isUsePhone = () => isUsePhone();

    // 获取登录用户信息
    Vue.prototype.$getUserInfo = () => getUserInfo();

    // 获取用户头像
    Vue.prototype.$headImg = () => headImg();
  }
};



// WEBPACK FOOTER //
// ./src/util/axios.js